import { CONTACT_CONFIG } from '@/config';

export const COMMON_CONTENT = {
  brand: {
    name: 'BST - The Soft Studio',
    shortName: 'BST',
    tagline: 'Handcrafted Joy in Every Hug',
    email: CONTACT_CONFIG.email,
    phone: CONTACT_CONFIG.phone,
    address: CONTACT_CONFIG.address,
  },
  loading: 'Loading...',
  processing: 'Processing...',
  pleaseWait: 'Please wait...',
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    close: 'Close',
    back: 'Back',
    submit: 'Submit',
    continue: 'Continue',
    shopNow: 'Shop Now',
  },
  placeholders: {
    search: 'Search for toys...',
    email: 'Enter your email',
    name: 'Full Name',
  },
} as const;

export const MISC_CONTENT = {
  browseShopLabel: 'Browse Shop',
  popularPagesTitle: 'Popular Pages',
  errorFooter: 'If you think this is a mistake, please contact support.',
} as const;

export const POPULAR_PAGES = [
  { label: 'Shop All', path: '/shop' },
  { label: 'New Arrivals', path: '/shop?category=new' },
  { label: 'Gift Guide', path: '/gift-guide' },
  { label: 'Contact Us', path: '/contact' },
] as const;

export const API_ERROR_CONTENT = {
  networkError: 'Network error. Please check your connection and try again.',
  timeoutError: 'Request timed out. Please try again.',
  serverError: 'Server error. Please try again later.',
  unauthorized: 'Your session has expired. Please sign in again.',
  forbidden: 'You do not have permission to perform this action.',
  notFound: 'The requested resource was not found.',
  validationError: 'Please check your input and try again.',
  unknownError: 'An unexpected error occurred. Please try again.',
} as const;
